/**
 * Created by Kamotin on 22.05.2017.
 */

var PromotionsService = (function () {


    function checkRewardItems(promoId, position) {

        $.post('/promotions/check/checkEqualsThree/' + promoId, function (response) {

            if (response.result.length !== 0) {

                $('.js-cart-all-reward-items').show();
                var sum = '';
                var element = $('.js-cart-reward-item');


                $.each(response.result, function (index, item) {
                    $.each(item.items, function (index, i) {

                        element.show();

                        element.find('.js-cart-reward-item-promo-id').attr('value', item.id);
                        element.find('.js-cart-reward-item-item-id').attr('value', i.id);
                        element.find('.js-cart-reward-item-image').attr('style', 'background-image: url(/pics/'
                            + i.picture + '); background-size: cover; background-position: center;');
                        element.find('.js-cart-reward-item-title').text(i.title);

                        sum += element.html();
                    });
                });


                $('.js-cart-reward-item').hide();
                $('.js-cart-all-reward-items').html(sum);
                $('#position').attr('value', position);
                $('#modalChangePromoItem').modal('show');
            } else {
                $('.js-cart-all-reward-items').hide();
            }
        });
    }

    function displayPromoReadMoreOnPictureClick() {
        $('.js-promotions-item').filter(function () {
            var element = $(this);
            $(this).find('.js-click-display-promotion').click(function () {
                var el = $(this);
                var target = el.data('target');
                if (target !== undefined) {
                    $(target).modal('show');
                }
            });
        });
    }

    function init() {

        displayPromoReadMoreOnPictureClick();

        $('.js-cart').on('click', '.js-cart-promotion-item-change', function () {
            $('.modal.in').modal('hide');
            var pos = $(this).data('pos');
            var promoId = $(this).data('promo');
            checkRewardItems(promoId, pos);
        });

        $('.js-cart').on('click', '.js-cart-item-coupon-change', function () {
            $('.modal.in').modal('hide');
            // у купона всегда 1 элемент
            var pos = 0;
            OrderService.checkChooseItemPayload(pos);
        });

        $('.js-promotions-item').filter(function () {
            var element = $(this);
            var picture = element.data('picture');
            var title = element.data('title');
            var fullWorkingTimeString = element.data('full-working-time-string');
            var description = element.data('description');

            element.find('.js-promotions-item-read-more').click(function () {
                $('#promotionsItemReadMore').modal('show');

                $('.js-promotions-item-read-more-picture').attr('style', 'background-image: url(/pics/' + picture + ');');
                $('.js-promotions-item-read-more-title').text(title);
                $('.js-promotions-item-read-more-full-working-time-string').text(fullWorkingTimeString);
                $('.js-promotions-item-read-more-description').html(description);
            })
        });

        $('.js-promotion-sw-active').click(function (e) {
            e.preventDefault();
            $('.js-promotion-sw-active').addClass('is-active');
            $('.js-promotions-list-active').removeClass('is-hide');
        });
    }

    return {
        init: init
    }
})();

$(PromotionsService.init);